import React, {useEffect, useRef} from "react"
import {useSelector, useDispatch} from "react-redux"
import {setCustomerDetails} from "redux/actions"
import {useParams} from "react-router-dom"
import {useConfig} from "hooks/useConfig"
import "./customer-details.scss"
import {useGetCustomerDetails} from "hooks/useGetCustomerDetails"

const CustomerDetails = () => {
  const {customers} = useSelector(({checkout}) => checkout)
  const autoFilledRef = useRef(false)

  const {getCustomerDetailsOnCheckoutForCateringMealKitOrder} = useConfig()
  const dispatch = useDispatch()
  const {checkoutType} = useParams()
  const isCateringMealKit = checkoutType === "catering-meal"

  const shouldGetCustomerDetails = Boolean(
    isCateringMealKit && getCustomerDetailsOnCheckoutForCateringMealKitOrder
  )
  const {data: customerData} = useGetCustomerDetails()
  const {first_name, last_name, email_id} = customerData ?? {}

  useEffect(() => {
    return () => {
      autoFilledRef.current = false
    }
  }, [])

  useEffect(() => {
    if (autoFilledRef.current) return

    if (!first_name || !last_name || !email_id) return

    if (customers?.length && Object.values(customers[0]).some(value => value)) return

    let updatedCustomers = [{firstName: first_name, lastName: last_name, email: email_id}]
    if (customers.length === 1) {
      updatedCustomers = [...customers]
      updatedCustomers[0].firstName = first_name
      updatedCustomers[0].lastName = last_name
      updatedCustomers[0].email = email_id
    }

    autoFilledRef.current = true
    dispatch(setCustomerDetails({customers: updatedCustomers}))
  }, [customers, customers.length, dispatch, email_id, first_name, last_name])

  const handleAddCustomer = () => {
    const newCustomer = {firstName: "", lastName: "", email: ""}
    const updated = [...customers, newCustomer]
    dispatch(setCustomerDetails({customers: updated}))
  }

  const handleRemoveCustomer = index => {
    const updated = customers.filter((_, i) => i !== index)
    dispatch(setCustomerDetails({customers: updated}))
  }

  const updateCustomerDetails = (index, data) => {
    const updated = [...customers]
    updated[index] = {...updated[index], ...data}
    if (updated[index].email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(updated[index].email)) {
      updated[index].emailError = "Please enter a valid email address."
    } else {
      updated[index].emailError = ""
    }
    dispatch(setCustomerDetails({customers: updated}))
  }

  if (!shouldGetCustomerDetails) {
    return null
  }

  return (
    <div className="note-text-style custom-details" style={{paddingTop: 25}}>
      <div className="form-detail custom-detail-wrap">
        <div className="title-items">
          <h3>Pickup Person</h3>
            <button onClick={handleAddCustomer}  title="+ Add">+ Add</button>
        </div>
        {customers.map((customer, index) => (
          <div className="form-field-item" key={index}>
            <>
              <div className="form-detail-wrap">
                <div className="form-control">
                  <Label index={index} htmlFor="firstName" Text="First Name" />
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    maxLength="100"
                    value={customer?.firstName}
                    onChange={e =>
                      updateCustomerDetails(index, {firstName: e.target.value})
                    }
                  />
                </div>

                <div className="form-control">
                  <Label index={index} htmlFor="lastName" Text="Last Name" />
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    maxLength="100"
                    value={customer?.lastName}
                    onChange={e =>
                      updateCustomerDetails(index, {lastName: e.target.value})
                    }
                  />
                </div>

                <div className="form-control">
                  <Label index={index} htmlFor="email" Text="Email" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={customer?.email}
                    onChange={e =>
                      updateCustomerDetails(index, {email: e.target.value})
                    }
                  />
                </div>
                {customer?.emailError && <div className="error" id="guest-email-error">{customer?.emailError}</div>}
              </div>
              <div className="form-control add-btn-wrap">
                {customers.length > 1 && index !== 0 && (
                  <button
                    type="button"
                    className="close-btn"
                     title="Close"
                    onClick={() => handleRemoveCustomer(index)}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                )}
              </div>
            </>
          </div>
        ))}
      </div>
    </div>
  )
}

function Label({index, htmlFor, Text}) {
  if (index === 0) {
    return <label htmlFor={htmlFor} style={{padding: "0 0 2px 0"}}>{Text}</label>
  }
  return null
}

export default CustomerDetails
